import React, { useRef, useState, useEffect } from 'react';
import { TouchableOpacity, Animated } from 'react-native';
import { styles } from './AvailabilitySubscription.styles';
import { isUserLoggedIn } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { withCookies } from 'react-cookie';
import { LOGIN_PAGE_URL } from '@mmt/rails/src/RailsConfig';

interface CustomSwitchProps {
  isEnabled: boolean;
  onSwitchChange: () => void;
  cookies: any;
}

const ToggleSlider = ({ isEnabled, onSwitchChange, cookies }: CustomSwitchProps) => {
  const animation = useRef(new Animated.Value(isEnabled ? 1 : 0)).current;
  const [isUserLogged, setIsUserLogged] = useState(false);
  useEffect(() => {
    const checkLoginStatus = async () => {
      const loggedIn = await isUserLoggedIn();
      setIsUserLogged(loggedIn);
    };
    checkLoginStatus();
  }, []);

  useEffect(() => {
    const postLoginAction = sessionStorage.getItem('postLoginAction');
    if (postLoginAction === 'toggleSwitch' && isUserLogged) {
      onSwitchChange();
      sessionStorage.removeItem('postLoginAction');
    }
  }, [isUserLogged, onSwitchChange]);

  Animated.timing(animation, {
    toValue: isEnabled ? 1 : 0,
    duration: 100,
    useNativeDriver: true,
  }).start();

  const thumbTranslate = animation.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  });

  const backgroundColor = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ['#EAF5FF', '#008CFF'],
  });

  const thumbColor = animation.interpolate({
    inputRange: [0, 1],
    outputRange: ['#0000004D', '#FFFFFF'],
  });

  const toggleSliderClicked = async () => {
    const isLogged = await isUserLoggedIn();
    if (!isLogged){
      const loginActionDetails = {
        actionURL: window.location.href,
        verifyOTP: false,
        isOTPVerified: false,
        openVerifiedPage: false,
        optPageOpened: false,
        postLoginAction: 'toggleSwitch',
      };
      const expires = new Date(Date.now() + 1200000);
      cookies.set('loginActionDetails', JSON.stringify(loginActionDetails), {
        expires,
        path: '/',
        domain: '.makemytrip.com',
      });
      sessionStorage.setItem('postLoginAction', 'toggleSwitch');
      window.location.href = LOGIN_PAGE_URL;
    } else {
      onSwitchChange();
    }
  };

  return (
    <TouchableOpacity
      style={[
        isEnabled ? styles.customSwitchTrackActive : styles.customSwitchTrackDisabled,
      ]}
      onPress={toggleSliderClicked}
    >
      <Animated.View
        style={[
          isEnabled ? styles.customSwitchButtonActive : styles.customSwitchButtonDisabled,
          { transform: [{ translateX: thumbTranslate }], backgroundColor: thumbColor },
        ]}
      />
    </TouchableOpacity>
  );
};

export default withCookies(ToggleSlider);